export default {
  weak: '0.2',
  medium: '0.6',
  strong: '0.9',
};
